import { CategorizationLayout } from '../../../components/Categorization';

export function RebateTypes() {
  return <CategorizationLayout type="rebateType" translationContext="male" omitFields={['searchKeywords']} />;
}
